import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import withRouter from "../../Common/withRouter";
import { createSelector } from 'reselect';

import { useSelector } from "react-redux";
import { authLogoutThunks } from "../../../store";
import { useThunk } from "../../../hooks/use_thunk";

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setUsername] = useState("");

  const selectProfileProperties = createSelector(
    (state: any) => state.auth.user,
    (profile) => ({
      user: profile?.user,
    })
  );

  const { user } = useSelector(selectProfileProperties);
  const {runThunk: doLogout, isLoading: isLoadingLogout, error: LoadingLogoutError} = useThunk(authLogoutThunks);
  const logout = ()=>{
    doLogout();
  }

  useEffect(() => {
    if (user && user?.username && (process.env.REACT_APP_DEFAULTAUTH === "fake" || process.env.REACT_APP_DEFAULTAUTH === "jwt")) {
      setUsername(user.username);
    }
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser") || "");
        setUsername(obj.displayName);
      }
    }
  }, [user]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <span><i className="fa fa-user"></i></span>
          <span className="d-none d-xl-inline-block ms-2 me-1">{username || "admin"}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/profile"}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <div className="dropdown-divider" />
          <div className="dropdown-item" onClick={logout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));